import { PaginatedFavoritedSamples } from 'apollo/sample/sample.gql';
import { PaginatedFavoritedPacksAndRepacks } from 'apollo/packAndRepack/packAndRepack.gql';

const favoritesQueryConfig = {
    samples: {
        query: PaginatedFavoritedSamples,
        pathToItems: 'paginatedFavoritedSamples',
        pathToTotalItems: 'totalSampleRecords',
    },
    packs: {
        query: PaginatedFavoritedPacksAndRepacks,
        pathToItems: 'paginatedFavoritedPacksAndRepacksV2',
        pathToTotalItems: 'totalRecords',
    },
};

export default favoritesQueryConfig;
